<template>
  <Wrapper>
    <label
      >病歷號&nbsp;:&nbsp;{{
        patient.info.patientNo
      }}
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;姓名&nbsp;:&nbsp;&nbsp;</label
    >
    <label v-if="isLineDevelop"> {{ data.form.姓名 }}</label>
    <input
      v-model="data.form.姓名"
      v-else
      type="text"
      size="10"
      style=" margin-left: 5px;font-size: 16px; border:1px; border-bottom-style: solid;border-top-style: none;border-left-style:none;border-right-style:none;"
      :disabled="haveSubmited"
    />
    <br />
    <br />
    <p>
      身分證字號
      <label v-if="isLineDevelop"> &nbsp;{{ data.form.身分證字號 }}</label>
      <input
        v-else
        v-model="data.form.身分證字號"
        type="text"
        size="12"
        style=" margin-left: 5px;font-size: 16px; border:1px; border-bottom-style: solid;border-top-style: none;border-left-style:none;border-right-style:none;"
        :disabled="haveSubmited"
      />
    </p>
    <br />
    <p>
      生日
      <label v-if="isLineDevelop"> &nbsp;{{ data.form.生日 }}</label>
      <input
        v-else
        v-model="data.form.生日"
        type="date"
        size="12"
        style=" margin-left: 5px; font-size: 16px; border:1px; border-bottom-style: solid;border-top-style: none;border-left-style:none;border-right-style:none;"
        :disabled="haveSubmited"
      />
    </p>
    <br />
    <p>
      手機
      <label v-if="isLineDevelop"> &nbsp;{{ data.form.手機 }} </label>
      <input
        v-else
        v-model="data.form.手機"
        type="text"
        size="19"
        style=" margin-left: 5px;font-size: 16px; border:1px; border-bottom-style: solid;border-top-style: none;border-left-style:none;border-right-style:none;"
        :disabled="haveSubmited"
      />
    </p>
    <br />
    <p>
      <span style="color:red;">*</span>地址<span style="font-size:12px;">
        (必填)</span
      ><input
        v-model="data.form.地址"
        type="text"
        style="width:100%; margin-left: 5px;font-size: 16px; border:1px; border-bottom-style: solid;border-top-style: none;border-left-style:none;border-right-style:none;"
        :disabled="haveSubmited"
      />
    </p>

    <br />
    <br />
    <p>
      血型
      <button class="clear-button" @click="nullify(data.form.血型)">
        清除
      </button>
    </p>
    <br />
    <div class="radiosBox">
      <label class="radioBox" for="paytype1-1"
        ><input
          v-model="data.form.血型.ABO"
          value="A"
          type="radio"
          id="paytype1-1"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>A</label
      >
      <label class="radioBox" for="paytype1-2"
        ><input
          v-model="data.form.血型.ABO"
          value="B"
          type="radio"
          id="paytype1-2"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>B</label
      >
      <label class="radioBox" for="paytype1-3"
        ><input
          v-model="data.form.血型.ABO"
          value="AB"
          type="radio"
          id="paytype1-3"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>AB</label
      >
      <label class="radioBox" for="paytype1-4"
        ><input
          v-model="data.form.血型.ABO"
          value="O"
          type="radio"
          id="paytype1-4"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>O</label
      >
    </div>
    <div class="radiosBox">
      <label class="radioBox" for="paytype2-1"
        ><input
          v-model="data.form.血型.RH"
          value="RH+"
          type="radio"
          id="paytype2-1"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>RH+</label
      >
      <label class="radioBox" for="paytype2-2"
        ><input
          v-model="data.form.血型.RH"
          value="RH-"
          type="radio"
          id="paytype2-2"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>RH-</label
      >
    </div>
    <p>
      遺傳疾病
      <button class="clear-button" @click="nullify(data.form.遺傳疾病)">
        清除
      </button>
    </p>
    <br />
    <div class="radiosBox">
      <label class="radioBox" for="paytype3-1"
        ><input
          v-model="data.form.遺傳疾病.有無"
          value="無"
          type="radio"
          id="paytype3-1"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>無</label
      >
      <label class="radioBox" for="paytype3-2"
        ><input
          v-model="data.form.遺傳疾病.有無"
          value="有"
          type="radio"
          id="paytype3-2"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>有，</label
      >
      <input
        v-model="data.form.遺傳疾病.病名"
        type="text"
        class="inputBox line"
        placeholder=" 遺傳病名"
        :disabled="haveSubmited"
      />
    </div>
    <p>
      內科病史
      <button class="clear-button" @click="nullify(data.form.內科病史)">
        清除
      </button>
    </p>
    <br />
    <div class="checksBox">
      <label class="checkMC"
        ><input
          v-model="data.form.內科病史.無"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        無</label
      >
      <br />
      <label class="checkMC"
        ><input
          v-model="data.form.內科病史.糖尿病"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        糖尿病</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.內科病史.高血壓"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        高血壓</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.內科病史.氣喘"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        氣喘</label
      >
      <br />
      <label class="checkMC"
        ><input
          v-model="data.form.內科病史.甲狀腺亢進"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        甲狀腺亢進</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.內科病史.甲狀腺低下"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        甲狀腺低下</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.內科病史.心臟病"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        心臟病</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.內科病史.肺病"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        肺病</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.內科病史.肝病"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        肝病</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.內科病史.腎病"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        腎病</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.內科病史.不明原因出血性疾病"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        不明原因出血性疾病</label
      >
    </div>
    <p>
      抽菸
      <button class="clear-button" @click="data.form.抽菸 = null">
        清除
      </button>
    </p>
    <br />
    <div class="radiosBox">
      <label class="radioBox" for="paytype4-1"
        ><input
          v-model="data.form.抽菸"
          value="無"
          type="radio"
          id="paytype4-1"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>無</label
      >
      <label class="radioBox" for="paytype4-2"
        ><input
          v-model="data.form.抽菸"
          value="有"
          type="radio"
          id="paytype4-2"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>有</label
      >
    </div>
    <p>
      手術史
      <button class="clear-button" @click="nullify(data.form.手術史)">
        清除
      </button>
    </p>
    <br />
    <div class="radiosBox">
      <label class="radioBox" for="paytype5-1"
        ><input
          v-model="data.form.手術史.有無"
          value="無"
          type="radio"
          id="paytype5-1"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>無</label
      >
      <label class="radioBox" for="paytype5-2"
        ><input
          v-model="data.form.手術史.有無"
          value="有"
          type="radio"
          id="paytype5-2"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>有</label
      >
      <input
        v-model="data.form.手術史.手術名稱"
        type="text"
        class="inputBox line"
        placeholder="   手術名稱"
        :disabled="haveSubmited"
      />
      <br />
      <br />
      <input
        v-model="data.form.手術史.醫院"
        type="text"
        class="inputBox line"
        placeholder="   醫院名稱"
        :disabled="haveSubmited"
      />
      &nbsp;&nbsp;&nbsp;&nbsp;
      <input
        v-model="data.form.手術史.距今"
        type="text"
        class="inputBox line"
        placeholder="距今年/月/日"
        :disabled="haveSubmited"
      />
    </div>
    <p>
      藥物過敏史
      <button class="clear-button" @click="nullify(data.form.藥物過敏史)">
        清除
      </button>
    </p>
    <br />
    <div class="checksBox">
      <label class="checkMC"
        ><input
          v-model="data.form.藥物過敏史.無"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        無</label
      >
      <br />
      <label class="checkMC"
        ><input
          v-model="data.form.藥物過敏史.匹林"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        Pryine 匹林</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.藥物過敏史.青黴素"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        Penicillin 青黴素</label
      >
      <br />
      <label class="checkMC"
        ><input
          v-model="data.form.藥物過敏史.其他"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        其他
      </label>
      <input
        v-model="data.form.藥物過敏史.其他藥名"
        type="text"
        class="inputBox line"
        placeholder="   藥物名稱"
        :disabled="haveSubmited"
      />
      <br />
      <br />
      藥物過敏反應程度
      <br />
      <br />
      <label class="checkMC"
        ><input
          v-model="data.form.藥物過敏史.皮膚癢"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        皮膚癢</label
      >
      <br />
      <label class="checkMC"
        ><input
          v-model="data.form.藥物過敏史.蕁麻疹水庖"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        蕁麻疹水庖</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.藥物過敏史.眼皮腫"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        眼皮腫</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.藥物過敏史.口腔潰瘍"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        口腔潰瘍</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.藥物過敏史.休克"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        休克</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.藥物過敏史.急救"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        急救</label
      >
    </div>
    <p>
      <span style="color:red;">*</span>月經史<span style="font-size:12px;">
        (必填)</span
      >
      <button class="clear-button" @click="nullify(data.form.月經史)">
        清除
      </button>
    </p>
    <br />
    <div class="radiosBox">
      最近一次月經開始日 :
      <input
        v-model="data.form.月經史.開始日"
        type="text"
        class="inputBox line"
        placeholder="   年/月/日"
        :disabled="haveSubmited"
      />
      <br />
      <br />
      週期是否規則 :
      <br />
      <br />
      <label class="radioBox" for="paytype6-1"
        ><input
          v-model="data.form.月經史.規則"
          value="是"
          type="radio"
          name="type6"
          id="paytype6-1"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>是</label
      >
      <input
        v-model="data.form.月經史.間隔幾天"
        type="text"
        class="inputBox line"
        placeholder="  間隔天數"
        :disabled="haveSubmited"
      />
      <label class="radioBox" for="paytype6-2"
        ><input
          v-model="data.form.月經史.規則"
          value="否"
          type="radio"
          name="type6"
          id="paytype6-2"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>否</label
      >
      <label class="radioBox" for="paytype6-3"
        ><input
          v-model="data.form.月經史.規則"
          value="已停經"
          type="radio"
          name="type6"
          id="paytype6-3"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>已停經</label
      >
    </div>

    <p>
      預產期
      <button class="clear-button" @click="data.form.預產期 = ''">
        清除
      </button>
    </p>
    <br />
    <input
      v-model="data.form.預產期"
      type="text"
      class="inputBox line"
      placeholder="   年/月/日"
      :disabled="haveSubmited"
    />

    <p>
      經期狀況
      <button class="clear-button" @click="nullify(data.form.經期狀況)">
        清除
      </button>
    </p>
    <br />
    <div class="radiosBox">
      經期天數 :
      <label class="radioBox" for="paytype7-1"
        ><input
          v-model="data.form.經期狀況.天數"
          value="3less"
          type="radio"
          id="paytype7-1"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>少於3天</label
      >
      <label class="radioBox" for="paytype7-2"
        ><input
          v-model="data.form.經期狀況.天數"
          value="3-5"
          type="radio"
          id="paytype7-2"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>3~5天</label
      >
      <label class="radioBox" for="paytype7-3"
        ><input
          v-model="data.form.經期狀況.天數"
          value="5-7"
          type="radio"
          id="paytype7-3"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>5~7天</label
      >
      <label class="radioBox" for="paytype7-4"
        ><input
          v-model="data.form.經期狀況.天數"
          value="7-10"
          type="radio"
          id="paytype7-4"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>7~10天</label
      >
      <label class="radioBox" for="paytype7-5"
        ><input
          v-model="data.form.經期狀況.天數"
          value="10more"
          type="radio"
          id="paytype7-5"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>10天以上</label
      >
    </div>
    <div class="radiosBox">
      經血量 :
      <label class="radioBox" for="paytype8-1"
        ><input
          v-model="data.form.經期狀況.經血量"
          value="多有血塊"
          type="radio"
          id="paytype8-1"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>多有血塊</label
      >
      <label class="radioBox" for="paytype8-2"
        ><input
          v-model="data.form.經期狀況.經血量"
          value="少量"
          type="radio"
          id="paytype8-2"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>少量</label
      >
      <label class="radioBox" for="paytype8-3"
        ><input
          v-model="data.form.經期狀況.經血量"
          value="中量"
          type="radio"
          id="paytype8-3"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>中量</label
      >
      <label class="radioBox" for="paytype8-4"
        ><input
          v-model="data.form.經期狀況.經血量"
          value="多量"
          type="radio"
          id="paytype8-4"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>多量</label
      >
    </div>
    <div class="radiosBox">
      經痛 :
      <label class="radioBox" for="paytype9-1"
        ><input
          v-model="data.form.經期狀況.經痛"
          value="無"
          type="radio"
          id="paytype9-1"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>無</label
      >
      <label class="radioBox" for="paytype9-2"
        ><input
          v-model="data.form.經期狀況.經痛"
          value="有"
          type="radio"
          id="paytype9-2"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>有</label
      >
    </div>
    <p>
      婚姻狀況
      <button class="clear-button" @click="nullify(data.form.婚姻狀況)">
        清除
      </button>
    </p>
    <br />
    <div class="radiosBox">
      <label class="radioBox" for="paytype10-1"
        ><input
          v-model="data.form.婚姻狀況.有無"
          value="已婚"
          type="radio"
          id="paytype10-1"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>已婚</label
      >
      <label class="radioBox" for="paytype10-2"
        ><input
          v-model="data.form.婚姻狀況.有無"
          value="未婚"
          type="radio"
          id="paytype10-2"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>未婚</label
      >
    </div>
    <p>
      最近服用藥物
      <button class="clear-button" @click="nullify(data.form.最近服用藥物)">
        清除
      </button>
    </p>
    <br />
    <div class="checksBox">
      <label class="checkMC"
        ><input
          v-model="data.form.最近服用藥物.無"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        無</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.最近服用藥物.感冒藥"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        感冒藥</label
      >
      <br />
      <label class="checkMC"
        ><input
          v-model="data.form.最近服用藥物.止痛藥"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        止痛藥</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.最近服用藥物.賀爾蒙"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        賀爾蒙</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.最近服用藥物.心臟病藥"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        心臟病藥
      </label>
      <label class="checkMC"
        ><input
          v-model="data.form.最近服用藥物.減肥藥"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        減肥藥</label
      >
      <br />
      <label class="checkMC"
        ><input
          v-model="data.form.最近服用藥物.鎮靜安眠藥"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        鎮靜安眠藥</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.最近服用藥物.中藥"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        中藥</label
      >
      <br />
      <label class="checkMC"
        ><input
          v-model="data.form.最近服用藥物.其他"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        其他</label
      >
      <input
        v-model="data.form.最近服用藥物.其他藥名"
        type="text"
        class="inputBox line"
        placeholder=""
        :disabled="haveSubmited"
      />
    </div>
    <p>
      過去曾看診之婦產科，或醫療院所名稱
      <button
        class="clear-button"
        @click="nullify(data.form.過去曾看診之婦產科)"
      >
        清除
      </button>
    </p>
    <br />
    <input
      v-model="data.form.過去曾看診之婦產科.名字"
      type="text"
      class="inputBox line"
      placeholder=""
      :disabled="haveSubmited"
    />
    <p>
      <span style="color:red;">*</span>性行為<span style="font-size:12px;">
        (必填)</span
      >
      <button class="clear-button" @click="nullify(data.form.性行為)">
        清除
      </button>
    </p>
    <br />
    <div class="radiosBox">
      <label class="radioBox" for="paytype11-1"
        ><input
          v-model="data.form.性行為.有無"
          value="無"
          type="radio"
          id="paytype11-1"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>無</label
      >
      <label class="radioBox" for="paytype11-2"
        ><input
          v-model="data.form.性行為.有無"
          value="有"
          type="radio"
          id="paytype11-2"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>有</label
      >
    </div>
    <p>
      懷孕史
      <button class="clear-button" @click="nullify(data.form.懷孕史)">
        清除
      </button>
    </p>
    <br />
    <div class="radiosBox">
      <label class="radioBox" for="paytype12-1"
        ><input
          v-model="data.form.懷孕史.有無"
          value="無"
          type="radio"
          id="paytype12-1"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>無</label
      >
      <label class="radioBox" for="paytype12-2"
        ><input
          v-model="data.form.懷孕史.有無"
          value="有"
          type="radio"
          id="paytype12-2"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>有</label
      >
    </div>
    <!-- 生產史開始 -->
    <p>
      生產史
      <button class="clear-button" @click="nullify(data.form.生產史)">
        清除
      </button>
    </p>
    <br />
    <div class="checksBox">
      自然流產 :
      <input
        v-model="data.form.生產史.自然流產"
        type="text"
        class="inputBox line"
        placeholder="次數"
        :disabled="haveSubmited"
      />
      <br />
      <br />
      死胎 :
      <input
        v-model="data.form.生產史.死胎"
        type="text"
        class="inputBox line"
        placeholder="次數"
        :disabled="haveSubmited"
      />
      <br />
      <br />
      妊娠週數 :
      <input
        v-model="data.form.生產史.妊娠周數"
        type="text"
        class="inputBox line"
        placeholder="週數"
        :disabled="haveSubmited"
      />
      <br />
      <br />
      人工流產 :
      <input
        v-model="data.form.生產史.人工流產_次數"
        type="text"
        class="inputBox line"
        placeholder="次數"
        :disabled="haveSubmited"
      />
      &nbsp;&nbsp;
      <input
        v-model="data.form.生產史.人工流產_手術醫院"
        type="text"
        class="inputBox line"
        placeholder="手術醫院"
        :disabled="haveSubmited"
      />
      <br /><br />
      自然生產 :
      <input
        v-model="data.form.生產史.自然生產_次數"
        type="text"
        class="inputBox line"
        placeholder="次數"
        :disabled="haveSubmited"
      />
      &nbsp;&nbsp;
      <input
        v-model="data.form.生產史.自然生產_生產醫院"
        type="text"
        class="inputBox line"
        placeholder="生產醫院"
        :disabled="haveSubmited"
      />
      <br /><br />
      剖腹生產 :
      <input
        v-model="data.form.生產史.剖腹生產_次數"
        type="text"
        class="inputBox line"
        placeholder="次數"
        :disabled="haveSubmited"
      />
      &nbsp;&nbsp;
      <input
        v-model="data.form.生產史.剖腹生產_生產醫院"
        type="text"
        class="inputBox line"
        placeholder="生產醫院"
        :disabled="haveSubmited"
      />
      <br /><br />
      剖腹生產原因 :
      <br /><br />
      <label class="checkMC"
        ><input
          v-model="data.form.生產史.剖腹生產原因_產程過長"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        產程過長</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.生產史.剖腹生產原因_胎位不正"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        胎位不正</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.生產史.剖腹生產原因_胎兒體重超過4000克"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        胎兒體重超過4000克</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.生產史.剖腹生產原因_前置胎盤"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        前置胎盤
      </label>
      <label class="checkMC"
        ><input
          v-model="data.form.生產史.剖腹生產原因_胎兒窘迫"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        胎兒窘迫</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.生產史.剖腹生產原因_其他"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        其他</label
      >
      <input
        v-model="data.form.生產史.剖腹生產原因_其他原因"
        type="text"
        class="inputBox line"
        placeholder=""
        :disabled="haveSubmited"
      />
      <br /><br />
      現有小孩 :
      <input
        v-model="data.form.生產史.現有小孩_男孩人數"
        type="text"
        class="inputBox line"
        placeholder="男孩人數"
        :disabled="haveSubmited"
      />
      &nbsp;&nbsp;
      <input
        v-model="data.form.生產史.現有小孩_女孩人數"
        type="text"
        class="inputBox line"
        placeholder="女孩人數"
        :disabled="haveSubmited"
      />
      <br /><br />
      最後一次生產是 :
      <input
        v-model="data.form.生產史.最後一次生產"
        type="text"
        class="inputBox line"
        placeholder="民國幾年"
        :disabled="haveSubmited"
      />
    </div>
    <!-- 生產史結束 -->
    <p>
      目前避孕方式
      <button class="clear-button" @click="nullify(data.form.目前避孕方式)">
        清除
      </button>
    </p>
    <br />
    <div class="checksBox">
      <label class="checkMC"
        ><input
          v-model="data.form.目前避孕方式.無"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        無</label
      >
      <br />
      <label class="checkMC"
        ><input
          v-model="data.form.目前避孕方式.避孕藥"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        避孕藥</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.目前避孕方式.保險套"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        保險套</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.目前避孕方式.避孕器"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        避孕器
      </label>
      <label class="checkMC"
        ><input
          v-model="data.form.目前避孕方式.避孕貼片"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        避孕貼片</label
      >
      <br />
      <label class="checkMC"
        ><input
          v-model="data.form.目前避孕方式.女性結紮"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        女性結紮</label
      >
      <label class="checkMC"
        ><input
          v-model="data.form.目前避孕方式.男性結紮"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        男性結紮</label
      >
      <br />
      <label class="checkMC"
        ><input
          v-model="data.form.目前避孕方式.其他"
          type="checkbox"
          :disabled="haveSubmited"
        />
        <div class="box"></div>
        其他</label
      >
      <input
        v-model="data.form.目前避孕方式.其他方式"
        type="text"
        class="inputBox line"
        placeholder=""
        :disabled="haveSubmited"
      />
    </div>
    <p>
      今年是否曾做過子宮頸抹片檢查
      <button class="clear-button" @click="nullify(data.form.子宮頸抹片)">
        清除
      </button>
    </p>
    <br />
    <div class="radiosBox">
      <label class="radioBox" for="paytype13-1"
        ><input
          v-model="data.form.子宮頸抹片.是否"
          value="是"
          type="radio"
          id="paytype13-1"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>是</label
      >
      <label class="radioBox" for="paytype13-2"
        ><input
          v-model="data.form.子宮頸抹片.是否"
          value="否"
          type="radio"
          id="paytype13-2"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>否</label
      >
      <label class="radioBox" for="paytype13-3"
        ><input
          v-model="data.form.子宮頸抹片.是否"
          value="未曾做過"
          type="radio"
          id="paytype13-3"
          :disabled="haveSubmited"
        /><span class="circle"><span></span></span>未曾做過</label
      >
    </div>
    <input
      @click.prevent="showConfirm"
      type="submit"
      class="submitBtn"
      value="確認送出"
    />
    <modal
      v-if="modal.display"
      @close="modal.display = false"
      @confirm="submit"
      :modalSetting="modalSetting"
    >
      <template #header>{{ modal.header }}</template>
      <template #body>{{ modal.body }}</template>
    </modal>
    <modal
      v-if="alert.display"
      @close="alert.display = false"
      :modalSetting="alertSetting"
    >
      <template #header>{{ alert.header }}</template>
      <template #body>{{ alert.body }}</template>
    </modal>
  </Wrapper>
</template>

<script>
import Wrapper from "./Wrapper.vue";
export default {
  components: {
    Wrapper
  },
  props: ["patient", "platform"],
  emits: ["submit"],
  computed: {
    isLineDevelop() {
      return this.platform === "line" || this.platform === "develop";
    }
  },
  data() {
    return {
      haveSubmited: false,
      modal: {},
      modalSetting: {},
      alert: {},
      alertSetting: {},
      data: {
        form: {
          血型: {
            dummy: ""
          },
          遺傳疾病: {
            dummy: ""
          },
          內科病史: {
            dummy: ""
          },
          抽菸: {
            dummy: ""
          },
          手術史: {
            dummy: ""
          },
          藥物過敏史: {
            dummy: ""
          },
          月經史: {
            dummy: ""
          },
          經期狀況: {
            dummy: ""
          },
          婚姻狀況: {
            dummy: ""
          },
          最近服用藥物: {
            dummy: ""
          },
          過去曾看診之婦產科: {
            dummy: ""
          },
          性行為: {
            dummy: ""
          },
          懷孕史: {
            dummy: ""
          },
          生產史: {
            dummy: ""
          },
          目前避孕方式: {
            dummy: ""
          },
          子宮頸抹片: {
            dummy: ""
          }
        }
      }
    };
  },
  mounted() {
    // 把patient推到data即可
    this.data.form.patientNo = this.patient.info.patientNo;
    this.data.form.姓名 = this.patient.info.name;
    this.data.form.身分證字號 = this.patient.info.twid;
    this.data.form.生日 = this.patient.info.birthdate;
    this.data.form.手機 = this.patient.info.phone;

    if (this.patient.originForm !== null) {
      this.data.form = this.patient.originForm;
    }
    this.haveSubmited = this.patient.disableContent;
  },
  methods: {
    showConfirm() {
      console.log(this.data.form);
      if (!this.data.form.地址) {
        this.alert = {
          display: true,
          header: "提醒訊息",
          body: "請輸入您的地址 (必填)"
        };
      } else if (
        !this.data.form.月經史?.規則 ||
        (this.data.form.月經史?.規則 !== "已停經" &&
          !this.data.form.月經史?.開始日)
      ) {
        this.alert = {
          display: true,
          header: "提醒訊息",
          body: "請檢查您的月經史資料 (必填)"
        };
      } else if (!this.data.form.性行為?.有無) {
        this.alert = {
          display: true,
          header: "提醒訊息",
          body: "請選擇您的性行為狀況 (必填)"
        };
      } else {
        this.modalSetting = {
          isShowConfirm: true
        };
        this.modal = {
          display: true,
          header: "提醒訊息",
          body: "是否確定送出"
        };
      }
    },
    submit() {
      this.$emit("submit", this.data);
      this.modal.display = false;

      if (this.platform === "musoon") {
        return;
      }
      this.haveSubmited = true;
    },
    nullify(obj) {
      Object.keys(obj).forEach(i => {
        if (obj[i] && typeof obj[i] === "object") {
          this.nullify(obj[i]);
          return;
        }
        obj[i] = null;
      });
    }
  }
};
</script>

<style scoped>
.clear-button {
  background-color: #f19e4e;
  font-size: 0.7rem;
  color: white;
  padding: 0px 4px;
  border-radius: 5px;
}
</style>
